<template>
  <a-date-picker v-if="permission" v-model="timeValue" style="min-width: auto" placeholder="" show-time value-format="YYYY-MM-DD HH:mm:ss" @change="onBlur">
    <span class="edit-problem-time">{{ value || '--' }}</span>
  </a-date-picker>
  <span v-else class="problem-time">{{ value || '--' }}</span>
</template>

<script>
import { problemUpdateItem } from '@/api/event/problem';

export default {
  name: 'ProblemTimeEdit',
  props: {
    sourceId: {
      type: [String, Number],
      default: null
    },
    sourceValue: {
      type: String,
      default: null
    },
    item: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      value: null,
      timeValue: null
    };
  },
  computed: {
    permission() {
      return true;
    }
  },
  watch: {
    sourceValue: {
      handler(newVal) {
        this.value = newVal;
        this.timeValue = newVal;
      },
      immediate: true
    }
  },
  methods: {
    onBlur() {
      if (!this.timeValue || this.timeValue === this.sourceValue) {
        this.timeValue = this.sourceValue;
        return;
      }

      problemUpdateItem({ id: this.sourceId, item: this.item, value: this.timeValue })
        .then(() => {
          this.value = this.timeValue;
          this.$message.success('更新成功');
        })
        .catch(res => {
          this.timeValue = this.sourceValue;
          this.$message.warning(res.message);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.problem-time {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}

.edit-problem-time {
  cursor: pointer;
  display: block;
  line-height: 22px;
  padding: 0 4px;

  &:hover {
    background-color: #e4e4e4;
  }
}

:deep(.ant-calendar-picker) {
  width: 100%;
}

:deep(.ant-input) {
  border: none;
  border-radius: 0;
  background-color: transparent;
  border-bottom: 1px solid #1890ff;
  padding: 0;

  &:hover,
  &:focus {
    border-bottom: 1px solid #1890ff;
  }

  &:focus {
    border: none;
    box-shadow: none;
    border-bottom: 1px solid #1890ff;
  }
}
</style>
